import React from "react";
import { useModal } from "context/ModalContext";
import ConfirmationFRPaymentSpeed from "../Modals/ConfirmationFRPaymentSpeed";
import GenericModal from "./GenericModal";
import AddDocsNonFactored from "../Modals/AddDocsNonFactored";
import UploadDocumentsModal from "../Modals/UploadDocumentsModal";

export interface GeneralModalProps {
  props?: Record<string, any>;
  isOpen: boolean;
  closeModal: () => void;

  [key: string]: any;
}

const modalList: Record<string, React.FC<GeneralModalProps>> = {
  "confirmation-fr-payment-speed": ({ props, closeModal, isOpen }) => (
    <ConfirmationFRPaymentSpeed {...props} closeModal={closeModal} isOpen={isOpen} />
  ),
  "upload-non-factored-fr-documents": ({ props, closeModal, isOpen }) => (
    <AddDocsNonFactored {...props} closeModal={closeModal} isOpen={isOpen} />
  ),
  "upload-documents": ({ props, closeModal, isOpen }) => (
    <UploadDocumentsModal
      {...props}
      closeModal={closeModal}
      isOpen={isOpen}
      urlCallback={props?.urlCallback}
    />
  ),
  warning: ({ props, closeModal, isOpen }) => (
    <GenericModal
      {...props}
      closeModal={closeModal}
      isOpen={isOpen}
      title={props?.title || "Warning"}
      message={props?.message || "Something went wrong."}
      type="warning"
      onConfirm={props?.onConfirm}
      confirmText={props?.confirmText || "Confirm"}
      onClose={props?.onClose}
      closeText={props?.closeText || "Cancel"}
    />
  ),
  danger: ({ props, closeModal, isOpen }) => (
    <GenericModal
      {...props}
      closeModal={closeModal}
      isOpen={isOpen}
      title={props?.title || "Error"}
      message={props?.message || "An error occurred."}
      type="danger"
      onConfirm={closeModal || props?.onConfirm}
      confirmText={props?.confirmText || "Confirm"}
      onClose={props?.onClose}
      closeText={props?.closeText || "Close"}
    />
  ),
  success: ({ props, closeModal, isOpen }) => (
    <GenericModal
      {...props}
      closeModal={closeModal}
      isOpen={isOpen}
      title={props?.title || "Success"}
      message={props?.message || "Operation completed successfully."}
      type="success"
      onConfirm={props?.onConfirm}
      confirmText={props?.confirmText || "Confirm!"}
      onClose={props?.onClose}
      closeText={props?.closeText || "Cancel"}
    />
  ),
  info: ({ props, closeModal, isOpen }) => (
    <GenericModal
      {...props}
      closeModal={closeModal}
      isOpen={isOpen}
      title={props?.title || "Information"}
      message={props?.message || "Please note the following information."}
      type="info"
      onConfirm={props?.onConfirm}
      confirmText={props?.confirmText || "Got it"}
      onClose={props?.onClose}
      closeText={props?.closeText || "Close"}
    />
  )
};

interface ModalState {
  id: string;
  isOpen: boolean;
  props?: Record<string, any>;
}

const ModalWrapper: React.FC = () => {
  const { modals, closeModal } = useModal();

  return (
    <>
      {modals
        .filter((modal: ModalState) => modal.isOpen)
        .map((modal: ModalState) => {
          const ModalComponent = modalList[modal.id];
          if (!ModalComponent) return null;
          return (
            <ModalComponent
              key={modal.id}
              props={modal.props}
              closeModal={() => closeModal(modal.id)}
              isOpen={modal.isOpen}
            />
          );
        })}
    </>
  );
};

export default ModalWrapper;
